export const uploadFile = (file, seasonId) => {
  const data = new FormData();
  data.append('upload_preset', process.env.REACT_APP_CLOUDINARY_UPLOAD_IMAGE_PRESET);
  data.append('file', file);
  return fetch(`https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD}/upload`, {
    method: 'POST',
    body: data,
  }).then(response => {
    return response.json();
  });
};

export const uploadVideo = (file, seasonId) => {
  const data = new FormData();
  data.append('upload_preset', process.env.REACT_APP_CLOUDINARY_UPLOAD_VIDEO_PRESET);
  data.append('file', file);
  return fetch(`https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD}/upload`, {
    method: 'POST',
    body: data,
  }).then(response => {
    return response.json();
  });
};



// WEBPACK FOOTER //
// ./src/api/fileUploadAPI.js